import styled, { keyframes } from 'styled-components/macro';

export const slideIn = keyframes`
  0% {
    transform: translateX(50%);
    opacity:0.5;
  }
  100% {
    transform:translateX(0);
    opacity:1;
  }
`;

export const close = keyframes`
  0% {
    opacity:1;
  }
  100% {
    opacity: 0;
    max-height: 0;
    margin-top: 0;
  }
`;

export const Container = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  z-index: 99999;
  display: block;
`;

export const Message = styled.div`
  position: relative;
  padding: 1rem 4rem 1rem 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background-color: var(--color-background);
  box-shadow: var(--shadow-lg);
  border-radius: var(--border-radius-md);
  border: 1px solid var(--color-text-lightest);
`;

export const MessageText = styled.div`
  color: var(--color-text-dark);
  font-size: var(--font-size-sm);

  p {
    margin-top: 0;
  }
`;

export const MessageIcon = styled.div`
  justify-content: center;
  display: flex;
  align-items: center;
`;

export const CloseIcon = styled.div`
  position: absolute;
  right: 1.5rem;
  display: flex;
  cursor: pointer;
`;

export const MessageContainer = styled.div`
  padding: 0 1rem;
  width: 100%;
  max-width: 30rem;
  display: flex;
  animation: ${slideIn} 0.5s var(--ease-out-expo) both;
  margin-top: 1rem;
  max-height: 7rem;
  overflow-y: hidden;
  &.is-leaving {
    animation: ${close} 0.2s ease-in-out both;
  }
`;
